import './FestivalHero.css'
import FestivalLogoSVG from '../../media/svg/Honk_People_Web_small_header.svg'

export default function FestivalHero() {

  return (
    <div className="festival-hero-container">
        <img alt="Honk PDX" src={FestivalLogoSVG} className="bg-nature" />
        <h1 id="festival-header">HONK! PDX 2025 IS HAPPENING!</h1>
        
        <div className="day-container">
          <h2>Saturday July 26</h2>
          <h3>
            Alberta Neighborhood 
            (<a href="https://maps.app.goo.gl/wKPFuJGPcQAgpL8N7" 
                target="_blank"
                rel="noreferrer"
              >
                maps
            </a>) NE 16th and NE Alberta St. (1-6pm)
          </h3>
          <p>
            We are teaming up with Crushin' It for their infamous watermelon crushing event! Break a watermelon to the tunes of brass bands or just cheer on the fun. Watermelon wrestling to follow (waiver required).
          </p>
          <p>
            We will have two stages: one on 16th Ave and one at the <a href="https://maps.app.goo.gl/S1uKReCbkukD5eiD6" 
                target="_blank"
                rel="noreferrer"
              >
                Conscious Sedation Beer Garden
            </a>.
          </p>
          <p>
            More information about Crushin It' can be found on <a href="https://partiful.com/e/1CxdeIa9pPHTHUbdVhdq" 
                target="_blank"
                rel="noreferrer"
              >
                Partiful
            </a> or <a href="https://facebook.com/events/s/crushin-it-2025/1536939640618776/" 
                target="_blank"
                rel="noreferrer"
              >
                Facebook
            </a>.
          </p>
        </div>

        <div className="day-container">
          <h2>Sunday July 27th</h2>
          <h3>
            Montavilla Neighborhood
            (<a href="https://maps.app.goo.gl/XsgwAgpFcfdNwJSE6" 
                target="_blank"
                rel="noreferrer"
              >
                maps
            </a>) SE 80th and SE Stark St. (12-6pm)
          </h3>
          <p>
            We are very excited to sponsor a stage at this year's Montavilla Street Fair! This is a wonderful, joyous community event with vendors, music, and food galore! Come visit our stage at SE 80th and SE Stark St. outside of Montavilla Station.
          </p>
        </div>
    </div>
  )
}